import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "cropper-container tw-justify-around tw-flex tw-flex-col tw-p-[40px] tw-gap-[40px]" }
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-gap-[20px] cropper" }
const _hoisted_3 = { class: "main tw-relative" }
const _hoisted_4 = {
  key: 0,
  class: "overlay-rectangle"
}
const _hoisted_5 = {
  key: 1,
  class: "overlay-circle"
}
const _hoisted_6 = {
  id: "drag-btn",
  class: "tw-absolute tw-top-2 tw-left-2 tw-flex"
}
const _hoisted_7 = { class: "tw-absolute tw-top-2 tw-right-2 tw-flex tw-flex-col tw-gap-[4px]" }
const _hoisted_8 = { class: "tw-text-[14px] tw-font-[500] tw-text-[#211F58]" }
const _hoisted_9 = { class: "tw-text-[13px] tw-font-[400] tw-text-[#231F20] tw-opacity-60" }
const _hoisted_10 = { class: "tw-flex tw-flex-col tw-gap-[40px] md:tw-gap-[unset] md:tw-flex-row md:tw-justify-between tw-items-center action_wrapper" }
const _hoisted_11 = { class: "tw-flex tw-flex-col tw-h-[35px] tw-justify-between requirements" }
const _hoisted_12 = {
  key: 0,
  class: "tw-text-[#878787] tw-font-Poppins tw-text-[12px] tw-font-normal tw-font-[400] tw-leading-[135%]"
}
const _hoisted_13 = {
  key: 1,
  class: "tw-text-[#B7B7B7] tw-font-Poppins tw-text-[11px] tw-font-normal tw-font-[400] tw-leading-[135%]"
}
const _hoisted_14 = {
  key: 2,
  class: "tw-text-[#B7B7B7] tw-font-Poppins tw-text-[11px] tw-font-normal tw-font-[400] tw-leading-[135%] tw-w-[330px]"
}
const _hoisted_15 = { class: "tw-flex tw-items-center tw-flex-wrap tw-gap-[14px] actions" }
const _hoisted_16 = {
  key: 0,
  class: "overlay"
}

import { ref, Ref, watch, ComponentPublicInstance } from "vue";
import Modal from "./modal.vue";
import ModalHeader from "./modalHeader.vue";
import Button2 from "@/components/common/button2.vue";
import Button1 from "@/components/common/button1.vue";
import { Cropper, RectangleStencil, CircleStencil } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
// import "vue-advanced-cropper/dist/theme.compact.css";
import { getComponentUiText } from "@/utils/utilities";
import ZoomInIcon from "@/components/svgs/zoomInIcon.vue";
import ZoomOutIcon from "@/components/svgs/zoomOutIcon.vue";
import DragIcon from "@/components/svgs/dragIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'imageCropper',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
  src: {
    type: String,
    default: null,
  },
  srcType: {
    type: String,
    default: null,
  },
  title: {
    type: String,
    default: "",
  },
  formats: {
    type: String,
    default: "",
  },
  recommendations: {
    type: String,
    default: "",
  },
  isSmallScreen: {
    type: Boolean,
    default: false,
  },
  rounded: {
    type: Boolean,
    default: true,
  },
  useRectangleStencil: {
    type: Boolean,
    default: false,
  },
  className: {
    type: String,
    required: false,
    default: "",
  },
},
  emits: ["close", "croppedImg"],
  setup(__props, { emit: emits }) {

const props = __props;



const cropper: ComponentPublicInstance<typeof Cropper> | Ref = ref();
const cropScaleValue = ref(1);
const croppedImage: File | Ref = ref(null);
const isProcessing: boolean | Ref = ref(false);

const zoomInBtnColor: Ref = ref("#B7B7B7");
const zoomOutBtnColor: Ref = ref("#B7B7B7");
const dragBtnColor: Ref = ref("#B7B7B7");
const isMacOS = navigator.platform.toUpperCase().indexOf("MAC") >= 0;

watch(cropScaleValue, () => {
  isProcessing.value = true;
});

watch(props, () => {
  if (!props.visible) {
    cropScaleValue.value = 1;
  }
});

const setCroppedImg = async () => {
  const cropperInstance = cropper.value;
  const { canvas } = cropperInstance.getResult();
  if (props.srcType === "image/jpeg") {
    const ctx = canvas.getContext("2d");
    ctx.globalCompositeOperation = "destination-over";
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }
  croppedImage.value = canvas;
  isProcessing.value = false;
  emits("croppedImg", croppedImage.value);
};

const zoomIn = () => {
  const cropperInstance = cropper.value;
  cropperInstance.zoom(1.2);
};

const zoomOut = () => {
  const cropperInstance = cropper.value;
  cropperInstance.zoom(1 / 1.2);
};

return (_ctx: any,_cache: any) => {
  const _component_b_popover = _resolveComponent("b-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Modal, {
      visible: __props.visible,
      overlay: false,
      class: _normalizeClass(`${__props.className} !tw-max-w-[720px] tw-top-[54%]`)
    }, {
      default: _withCtx(() => [
        _createVNode(ModalHeader, {
          title: __props.title,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, null, 8, ["title"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(Cropper), {
                ref_key: "cropper",
                ref: cropper,
                class: _normalizeClass(`cropper ${
              isMacOS
                ? 'tw-cursor-grab active:tw-cursor-grabbing'
                : 'tw-cursor-move'
            }`),
                "background-class": "cropper__background",
                "foreground-class": "cropper__foreground",
                "stencil-component": 
              __props.useRectangleStencil ? _unref(RectangleStencil) : _unref(CircleStencil)
            ,
                src: __props.src,
                "stencil-size": {
              width: 600,
              height: __props.useRectangleStencil ? 240 : 600,
            },
                "stencil-props": {
              handlers: {},
              movable: false,
              resizable: false,
              lines: {
                north: false,
                west: false,
                south: false,
                east: false,
              },
            },
                "resize-image": {
              adjustStencil: false,
            },
                "image-restriction": "none"
              }, null, 8, ["class", "stencil-component", "src", "stencil-size"]),
              (__props.useRectangleStencil)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                : (_openBlock(), _createElementBlock("div", _hoisted_5)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "tw-w-[30px] tw-h-[30px] tw-flex tw-justify-center tw-items-center tw-bg-white tw-rounded-[6px] tw-cursor-pointer",
                  onMouseover: _cache[1] || (_cache[1] = ($event: any) => (dragBtnColor.value = '#387DFF')),
                  onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (dragBtnColor.value = '#B7B7B7'))
                }, [
                  _createVNode(DragIcon, { color: dragBtnColor.value }, null, 8, ["color"])
                ], 32)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "tw-w-[30px] tw-h-[30px] tw-flex tw-justify-center tw-items-center tw-bg-white tw-rounded-[6px] tw-cursor-pointer",
                  onClick: zoomIn,
                  onMouseover: _cache[3] || (_cache[3] = ($event: any) => (zoomInBtnColor.value = '#387DFF')),
                  onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (zoomInBtnColor.value = '#B7B7B7')),
                  onMousedown: _cache[5] || (_cache[5] = ($event: any) => (zoomInBtnColor.value = '#211F58')),
                  onMouseup: _cache[6] || (_cache[6] = ($event: any) => (zoomInBtnColor.value = '#387DFF'))
                }, [
                  _createVNode(ZoomInIcon, { color: zoomInBtnColor.value }, null, 8, ["color"])
                ], 32),
                _createElementVNode("div", {
                  class: "tw-w-[30px] tw-h-[30px] tw-flex tw-justify-center tw-items-center tw-bg-white tw-rounded-[6px] tw-cursor-pointer",
                  onClick: zoomOut,
                  onMouseover: _cache[7] || (_cache[7] = ($event: any) => (zoomOutBtnColor.value = '#387DFF')),
                  onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (zoomOutBtnColor.value = '#B7B7B7')),
                  onMousedown: _cache[9] || (_cache[9] = ($event: any) => (zoomOutBtnColor.value = '#211F58')),
                  onMouseup: _cache[10] || (_cache[10] = ($event: any) => (zoomOutBtnColor.value = '#387DFF'))
                }, [
                  _createVNode(ZoomOutIcon, { color: zoomOutBtnColor.value }, null, 8, ["color"])
                ], 32)
              ]),
              _createVNode(_component_b_popover, {
                class: "custom-cropper-popover",
                target: "drag-btn",
                placement: "bottom-end",
                trigger: "hover"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(getComponentUiText)(
                  "app-settings-organisation-profile-avatar-tooltip-header-1",
                )), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(getComponentUiText)(
                  "app-settings-organisation-profile-avatar-tooltip-body-1",
                )), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, [
              (__props.formats)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(getComponentUiText)(
                "app-settings-organisation-profile-avatar-cropper-image-requirements-1",
              )), 1))
                : _createCommentVNode("", true),
              (__props.formats)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(__props.formats), 1))
                : _createCommentVNode("", true),
              (__props.recommendations)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(__props.recommendations), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", _hoisted_15, [
              _createVNode(Button2, {
                class: "tw-text-center tw-font-Poppins tw-text-[15px] tw-font-[500] tw-leading-[100%] !tw-py-[12px] !tw-px-[18px]",
                title: _unref(getComponentUiText)('app-common-action-cancel-button-1'),
                disabled: isProcessing.value,
                onClick: _cache[11] || (_cache[11] = 
              () => {
                _ctx.$emit('close');
                cropScaleValue.value = 1;
              }
            )
              }, null, 8, ["title", "disabled"]),
              _createVNode(Button1, {
                class: "tw-text-center tw-font-Poppins tw-text-[15px] tw-font-[500] tw-leading-[100%] !tw-py-[12px] !tw-px-[18px]",
                title: _unref(getComponentUiText)('app-common-action-upload-button-1'),
                disabled: isProcessing.value,
                "data-cy": "image-cropper-upload-button",
                onClick: setCroppedImg
              }, null, 8, ["title", "disabled"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "class"]),
    (__props.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16))
      : _createCommentVNode("", true)
  ], 64))
}
}

})